import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { ComboPreventionResult } from './combo-prevention-result.enum';

export interface IComboPreventionValidator {
    validate(thisPick: BetslipPick, otherPick: BetslipPick, isSystemBet: boolean): ComboPreventionResult;
    canValidate(thisPick: BetslipPick, otherPick: BetslipPick, ignoreGroupInfo?: boolean): boolean;
}

export abstract class BaseComboPrevention<TThisPick extends BetslipPick, TOtherPick extends BetslipPick> implements IComboPreventionValidator {
    protected constructor(
        private thisType: typeof BetslipPick,
        private otherType: typeof BetslipPick,
    ) {}

    abstract validate(thisPick: TThisPick, otherPick: TOtherPick, isSystemBet: boolean): ComboPreventionResult;

    canValidate(thisPick: BetslipPick, otherPick: BetslipPick, ignoreGroupInfo: boolean = false): boolean {
        return (
            thisPick instanceof this.thisType &&
            otherPick instanceof this.otherType &&
            (ignoreGroupInfo || this.ensureDifferentGroups(thisPick, otherPick))
        );
    }

    /**
     * A function to ensure that 'thisPick' and 'otherPick' do not have the same group id,
     * with an exception for instances of type BaseBetslipGroupPick.
     *
     * @param thisPick - The first pick to compare.
     * @param otherPick - The second pick to compare.
     * @returns - Returns true if 'this' and 'other' have different group ids or no group ids at all
     *
     * 			-  Returns true if either picks are of type BaseBetslipGroupPick
     *
     *          - Returns false otherwise.
     *
     */
    private ensureDifferentGroups(thisPick: BetslipPick, otherPick: BetslipPick) {
        return (
            !thisPick.groupInfo ||
            !otherPick.groupInfo ||
            thisPick.groupInfo.groupId !== otherPick.groupInfo.groupId ||
            BaseBetslipGroupPick.isPick(thisPick) ||
            BaseBetslipGroupPick.isPick(otherPick)
        );
    }
}
